import React, { Component } from "react";
import "./footer.css";
import { isMobileDevice } from "../../helpers/Utils";
import Constants from "../../shared/constants/environmentConfig";
import youtube from "../../shared/images/landing_page/youtube.svg";
import linkedIn from "../../shared/images/landing_page/linkedin.svg";
import fb from "../../shared/images/landing_page/fb.svg";

const isMobile = isMobileDevice();
const ibWebDomain = Constants().cookie.ibWebDomain;
export default class Footer extends Component {
  renderWebFooter() {
    const engineeringCourses = [
      "JEE Main & Advance",
      "KCET",
      "MHCET",
      "APEAMCET",
    ];
    const medicalCourses = ["NEET", "AIIMS", "JIPMER"];
    return (
      <div className="footer-container flex-column-container">
        <div
          style={{
            display: "flex",
            marginBottom: 45,
            justifyContent: "space-between",
          }}
        >
          <div
            className="flex-column-container"
            style={{ justifyContent: "space-between" }}
          >
            <div>
              <div
                className="main-topic"
                style={{
                  margin: "0px 10px 25px 0px",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.location.replace(`${ibWebDomain}/careers`)
                }
              >
                Careers
              </div>
              <div className="flex-row-container" style={{ marginLeft: -10 }}>
                <div>
                  <a href="https://www.youtube.com/channel/UCVzzTmIWLd5uKUlU7LuakSQ">
                    <img src={youtube} alt="NEET_JEE_analysis_you_tube" />
                  </a>
                </div>
                <div>
                  <a href="https://www.linkedin.com/company/ideaboard/about/">
                    <img src={linkedIn} alt="NEET_JEE_analysis_linked_in" />
                  </a>
                </div>
                <div>
                  <a href="https://www.facebook.com/ideaboardtech/">
                    <img src={fb} alt="NEET_JEE_analysis_facebook" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-column-container">
            <div className="main-topic list-topic">PRODUCTS</div>
            <div className="list-topic">Question Board</div>
            <div className="list-topic">Mentor Board</div>
            <div className="list-topic">Insight Board</div>
          </div>

          <div
            className="flex-column-container"
            style={{ justifyContent: "space-between" }}
          >
            <div className="flex-row-container">
              <div
                className="flex-column-container"
                style={{ paddingRight: 80 }}
              >
                <div className="main-topic">ENGINEERING</div>
                {engineeringCourses.map((coarse) => {
                  return <div className="list-topic">{coarse}</div>;
                })}
              </div>
              <div className="flex-column-container">
                <div className="main-topic">MEDICAL</div>
                {medicalCourses.map((coarse) => {
                  return <div className="list-topic">{coarse}</div>;
                })}
              </div>
            </div>
          </div>

          <div
            className="flex-column-container"
            style={{ justifyContent: "space-between" }}
          >
            <div style={{ textAlign: "right", marginRight: -10 }}>
              <a
                href={`${
                  Constants().playStoreUrl
                }=utm_source%3DibWebsite%26utm_medium%3Daccounts%26utm_term%3DgetItOnGooglePlay`}
              >
                <img
                  className="google-play"
                  alt="NEET_JEE_analysis_app"
                  src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
                  width="140px"
                />
              </a>
            </div>
            <div
              className="flex-column-container"
              style={{ textAlign: "right" }}
            >
              <a
                href="https://www.google.com/maps/place/IdeaBoard+Technologies/@13.0105415,77.6492807,17z/data=!3m1!4b1!4m5!3m4!1s0x3bae16d491ffcbdd:0xb72fd2219e491927!8m2!3d13.0105415!4d77.6514694"
                target="_blank"
              >
                <div
                  className="main-topic"
                  style={{ marginBottom: 10, color: "#3C3C3C" }}
                >
                  OFFICE ADDRESS
                </div>
                <div style={{ color: "#5D5D5D" }}>
                  002, Platinum Castle, 3rd Main Rd{" "}
                </div>
                <div style={{ color: "#5D5D5D" }}>OMBR Layout, Banasawadi </div>
                <div style={{ color: "#5D5D5D" }}>
                  Bengaluru, Karnataka 560043
                </div>
              </a>
            </div>
          </div>
        </div>
        <div
          className="flex-row-container"
          style={{ justifyContent: "space-around", padding: "0px 160px" }}
        >
          <div
            className="list-topic"
            style={{ cursor: "pointer" }}
            onClick={() => window.location.replace(`${ibWebDomain}/terms`)}
          >
            Terms Of Services
          </div>
          <a href="mailto:support@ideaboard.xyz">
            <div className="list-topic" style={{ cursor: "pointer" }}>
              Contact Us
            </div>
          </a>
          <div
            className="list-topic"
            style={{ cursor: "pointer" }}
            onClick={() => window.location.replace(`${ibWebDomain}/privacy`)}
          >
            Privacy Policies
          </div>
        </div>
      </div>
    );
  }

  renderMobileFooter() {
    return (
      <div style={{ backgroundColor: "#F2F2F2", padding: "20px 0px 20px 0px" }}>
        <div className="footer1-mobile">
          <div className="connect-with-us-mobile">
            <div
              className="main-topic"
              style={{
                margin: "0px 10px 25px 0px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => window.location.replace(`${ibWebDomain}/careers`)}
            >
              Careers
            </div>
          </div>
          <div className="connect-mobile">
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div>
                <a href="https://www.youtube.com/channel/UCVzzTmIWLd5uKUlU7LuakSQ">
                  <img src={youtube} alt="NEET_JEE_you_tube" />
                </a>
              </div>
              <div>
                <a href="https://www.linkedin.com/company/ideaboard/about/">
                  <img src={linkedIn} alt="NEET_JEE_linked_in" />
                </a>
              </div>
              <div>
                <a href="https://www.facebook.com/ideaboardtech/">
                  <img src={fb} alt="NEET_JEE_facebook" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer2-mobile">
          <div className="with-us">
            <div className="address" style={{ textAlign: "center" }}>
              <a
                href="https://www.google.com/maps/place/IdeaBoard+Technologies/@13.0105415,77.6492807,17z/data=!3m1!4b1!4m5!3m4!1s0x3bae16d491ffcbdd:0xb72fd2219e491927!8m2!3d13.0105415!4d77.6514694"
                target="_blank"
              >
                <div
                  className="connect-with-us-mobile"
                  style={{ padding: "0px 0px 10px 0px", color: "#3C3C3C" }}
                >
                  OFFICE ADDRESS
                </div>
                <div style={{ color: "#5D5D5D" }}>
                  002,Platinum Castle,3rd Main Rd
                </div>
                <div style={{ color: "#5D5D5D" }}>OMBR Layout,Banasawadi</div>
                <div style={{ color: "#5D5D5D" }}>
                  Bengaluru,Karnataka 560043
                </div>
              </a>
            </div>
          </div>
        </div>
        <div
          className="footer3-mobile"
          style={{
            paddingTop: "10px",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{ color: "#5D5D5D", padding: "0px 20px 0px 0px" }}
            onClick={() => window.location.replace(`${ibWebDomain}/terms`)}
          >
            Terms Of Service
          </div>

          <a href={`tel:080-471-87111`}>
            <div style={{ color: "#5D5D5D", padding: "0px 20px 0px 0px" }}>
              Contact Us
            </div>
          </a>
          <div
            style={{ color: "#5D5D5D", padding: "0px 20px 0px 0px" }}
            onClick={() => window.location.replace(`${ibWebDomain}/privacy`)}
          >
            PrivacyPolicies
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>{isMobile ? this.renderMobileFooter() : this.renderWebFooter()}</div>
    );
  }
}
